import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"

interface ConfirmLinkProps {
  href: string
  className?: string
  text?: string
  style?: React.CSSProperties
  prompt?: string
  children?: React.ReactNode
}

const ConfirmLink: React.FC<ConfirmLinkProps> = ({ href, text, style, children, className, prompt }) => {
  const { t } = useTranslation()
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (!confirm(prompt || t("misc.confirm"))) {
        e.preventDefault()
      }
    },
    [t, prompt]
  )

  return (
    <a href={href} style={style} onClick={handleClick} className={className}>
      {children || text}
    </a>
  )
}

export default ConfirmLink
